module.exports = __webpack_public_path__ + "static/media/Gallery_1-min.b0f42401.jpg";